var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.4 44.8",
    style: {
      enableBackground: "new 0 0 34.4 44.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D8D8D8;}\n\t.st2{fill:#CC4B4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.2,44.3c-0.4,0-0.7-0.3-0.7-0.3l0-42.5c0-0.5,0.1-1,0.7-1h32.1c0.6,0,0.7,0.5,0.7,1V44c0,0-0.4,0.3-0.7,0.3 H1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,1c0.1,0,0.2,0,0.2,0.5v42.2c-0.1,0-0.1,0.1-0.2,0.1H1.2c-0.1,0-0.2,0-0.2,0V1.5C1,1,1.1,1,1.2,1H33.3  M33.3,0H1.2C0.5,0,0,0.5,0,1.5V44c0,0.3,0.5,0.8,1.2,0.8h32.1c0.6,0,1.2-0.5,1.2-0.8V1.5C34.5,0.5,34,0,33.3,0L33.3,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.4,26.7c-0.3,0-0.5-0.1-0.8-0.3c-0.8-0.6-0.9-1.3-0.9-1.8c0.1-1.3,1.8-2.7,4.8-4.1c1.2-2.6,2.3-5.9,3-8.6 c-0.8-1.7-1.6-4-1-5.3c0.2-0.5,0.4-0.8,0.9-1c0.2-0.1,0.6-0.1,0.8-0.1c0.4,0,0.8,0.5,1,0.8s0.8,0.9-0.3,5.4c1.1,2.2,2.6,4.5,4.1,6 c1.1-0.2,2-0.3,2.7-0.3c1.3,0,2,0.3,2.3,0.9c0.3,0.5,0.2,1.1-0.3,1.7c-0.4,0.6-1.1,1-1.8,1c-1,0-2.1-0.6-3.4-1.8 c-2.3,0.5-4.9,1.3-7.1,2.3c-0.7,1.4-1.3,2.6-1.9,3.4C11.8,26.1,11.1,26.7,10.4,26.7L10.4,26.7z M12.5,22.6c-1.7,1-2.4,1.8-2.5,2.2 c0,0.1,0,0.3,0.3,0.6C10.5,25.3,11.2,25,12.5,22.6L12.5,22.6z M23.4,19c0.7,0.5,0.8,0.8,1.2,0.8c0.2,0,0.7,0,1-0.4 c0.1-0.2,0.2-0.3,0.2-0.3c-0.1-0.1-0.2-0.2-0.9-0.2C24.5,18.9,24,18.9,23.4,19L23.4,19z M17.5,13.7c-0.6,2-1.3,4.1-2.1,6.1 c1.7-0.6,3.5-1.2,5.2-1.6C19.5,16.9,18.4,15.4,17.5,13.7L17.5,13.7z M17,7c-0.1,0-1.1,1.4,0.1,2.6C17.8,7.9,17,7,17,7L17,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.2,44.8h-32c-0.6,0-1.2-0.5-1.2-1.2V31.2h34.4v12.4C34.4,44.3,33.9,44.8,33.2,44.8L33.2,44.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.8d2d45a73e3482f23e2d9e287877ae2a.svg";
export { ForwardRef as ReactComponent };